import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import Property from "@/components/Property";

export default {
  name: "similar-homes",

  data() {
    return {
      swiper: null,
      loadingNextPage: false,
      swiperOption: {
        speed: 600,
        slidesPerView: 3,
        simulateTouch: false,
        allowTouchMove: false,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next.next",
          prevEl: ".swiper-button-prev.prev"
        },
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          576: {
            slidesPerView: "auto",
            spaceBetween: 16
          }
        },
        slidesPerGroup: 1,
        // loop: this.loop,
        // loopFillGroupWithBlank: true
      }
    };
  },

  props: {
    loop: {
      type: Boolean,
      default: true
    },

    properties: {
      type: Array,
      default: () => []
    },

    pagination: {
      type: Object,
      default: () => {}
    }
  },

  beforeDestroy() {
    this.swiper.destroy;
    this.swiper.destroy(false, false);
  },

  mounted() {
    this.swiper = this.$refs.similarSwiper.swiper;
  },

  computed: {
    // swiper() {
    //   return this.$refs.similarSwiper;
    // },
    isEnd() {
      return this.swiper ? this.swiper.isEnd : false;
    }
  },

  methods: {
    handleUpdatePropertyInteresting(data) {
      let entity = this.properties.find(p => p.id == data.id);
      entity.isInteresting = data.interesting;
    },

    triggerNextPage() {
      this.$emit("triggerNextPage");
      this.loadingNextPage = true;
    }
  },

  watch: {
    pagination() {
      this.loadingNextPage = false;
    }
  },

  components: {
    swiper,
    swiperSlide,
    Property
  }
};
